"use strict";
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import AuditsController from "./controller/audits";
import AuditTableDirective from "./directive/auditTable";
import AuditService from "./service/audit";
import action from "./module/action";

export default angular.module("investmentProject.audit", [action])
    .controller("AuditsController", AuditsController)
    .directive("auditTable", AuditTableDirective)
    .factory("AuditService", AuditService)
    .name;
